import { Box, Theme, Typography } from "@outschool/backpack";
import { CategoryPage } from "@outschool/gql-backend-generated";
import { onlineClassesPath } from "@outschool/routes";
import { TopicPill } from "@outschool/ui-components-website";
import { Carousel } from "@outschool/ui-legacy-component-library";
import lodashUniqBy from "lodash/uniqBy";
import React from "react";

// This file is not yet translated.
/* eslint-disable i18next/no-literal-string */
import Link from "../../components/Link";

export default function RelatedTopicsMagnetPage({
  category
}: {
  category: CategoryPage;
}) {
  const pills = lodashUniqBy(
    [
      ...(category.related ?? []),
      ...(category.children ?? []),
      ...(category.siblings ?? [])
    ],
    category => category?.slug
  );

  return (
    <Box
      sx={{
        width: "100%",
        maxWidth: "1120px",
        display: "block",
        margin: "auto"
      }}
    >
      <Typography
        sx={(theme: Theme) => ({
          fontSize: `${theme.typography.pxToRem(21)} !important`,
          fontWeight: 500,
          paddingLeft: "30px",
          my: theme.spacing(10)
        })}
        variant="h3"
      >
        {`Topics Related to ${category?.nameTitleCased ?? category?.name}`}
      </Typography>
      <Carousel sx={{ flexWrap: "wrap", justifyContent: "center" }}>
        {pills.map((cat: CategoryPage) => (
          <Link
            key={cat.slug}
            trackingName="magnet_page_online_classes_links"
            trackingUniqueId={cat.slug}
            to={onlineClassesPath(cat.slug, cat.basePath)}
          >
            <Box
              sx={{
                padding: "0.5em"
              }}
            >
              <TopicPill>{cat.nameTitleCased}</TopicPill>
            </Box>
          </Link>
        ))}
      </Carousel>
    </Box>
  );
}
